import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Image,
  Spinner,
  Modal,
  Button,
} from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom"; // Import useLocation
import { Mail } from "react-feather";

import { useNotification } from "../../components/notification";
import apiService from "../../services/apiService";

import logo from "../../logo.png";

const EmailConfirmation = () => {
  const navigate = useNavigate();

  const { showNotification } = useNotification();
  const [isPageLoading, setIsPageLoading] = useState(false);

  // Get the email from location state
  const location = useLocation();
  const email = location.state?.email;
  const from = location.state?.from;

  const redirectToLogin = () => {
    if (from) navigate("/login", { state: { from: "/checkout" } });
    else navigate("/login");
  };

  const handleResendEmail = async () => {
    try {
      setIsPageLoading(true);
      const response = await apiService.post("/email/resend-verification", {
        email,
      });
      showNotification("success", response.message, 5000);
    } catch (error) {
      showNotification(
        "danger",
        error.message || "Failed to resend confirmation email.",
        5000
      );
    } finally {
      setIsPageLoading(false);
    }
  };

  return (
    <Container className="min-vh-100 d-flex align-items-center justify-content-center flex-column">
      <Row>
        <Col xs={12} className="text-center mb-4">
          <Image
            src={logo}
            alt={`${process.env.REACT_APP_PORTAL}`}
            fluid
            width="225px"
          />
        </Col>
        <Col xs={11} md={8} lg={6} xl={5} xxl={4} className="m-auto">
          <Card className="p-4 shadow border-0">
            <Card.Body className="text-center">
              <Mail size={40} className="text-secondary mb-3" />
              <h1 className="text-center mb-3 fs-5">Confirm Your Email</h1>
              <p className="text-center mb-4 text-light-emphasis fw-light">
                Thank you for signing up. We’ve sent a verification email to{" "}
                <span className="text-primary fw-bold">{email}</span>. Kindly
                verify your email address to complete the registration and
                enable product purchases.
              </p>
              <hr className="mt-5 mb-4" />
              <div className="text-center text-light-emphasis fw-light fs-medium">
                Didn't receive the link?
                <Button
                  title="Resend Verification Email"
                  variant="link"
                  onClick={handleResendEmail}
                  className="text-decoration-none fw-semibold px-1 py-0"
                >
                  Resend
                </Button>
              </div>
              <div className="text-center text-light-emphasis fw-light fs-medium mt-1">
                Click here to
                <Button
                  title="Login"
                  variant="link"
                  onClick={redirectToLogin}
                  className="text-decoration-none fw-semibold px-1 py-0"
                >
                  Login
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Modal
        show={isPageLoading}
        aria-labelledby="Loading"
        className="modal-loading"
        contentClassName="bg-transparent border-0"
        centered
      >
        <Modal.Body className="text-center">
          <Spinner animation="border" role="status" variant="primary">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default EmailConfirmation;
